"use client";
import { Button, Spacer, Text } from "@zapier/design-system";

import { AccountSwitcher } from "../../components/AccountSwitcher";
import { CurrentAccountIdProvider } from "@zapier/identity";
import styles from "./ErrorStates.module.css";

export type ErrorType = {
  status: number;
  json?: {
    reason: string;
  };
};

export function ErrorStates({ error }: { error: ErrorType }) {
  const message = getMessage(error);

  if (message.showAccountSwitcher) {
    return (
      <CurrentAccountIdProvider>
        <AccountSwitcher />
      </CurrentAccountIdProvider>
    );
  }

  return (
    <div className={styles.container}>
      <h2>{message.title}</h2>
      <Text>{message.subtext}</Text>
      <Spacer height={20} />
      <Button
        onPress={() => {
          window.location.href = "/app/canvas";
        }}
      >
        Go back
      </Button>
    </div>
  );
}

function getMessage(error: ErrorType) {
  try {
    const errorObject = error;
    if (errorObject.status === 400) {
      if (errorObject.json?.reason === "LOOKUP_FAILED") {
        return {
          title:
            "Sorry, we ran into an issue looking up your permission to access this Canvas.",
          subtext:
            "While looking up if you have access to this Canvas, we encountered an error. Please try again later.",
        };
      }
    }
    if (errorObject.status === 404) {
      return {
        title: "Sorry, we can't seem to find this Canvas.",
      };
    }
    if (errorObject.status === 403) {
      if (errorObject.json?.reason === "NOT_SHARED_WITH_USER") {
        return {
          title: "You don't have access to this Canvas.",
          subtext: "Ask the owner to share it with you and try again.",
        };
      }
      if (errorObject.json?.reason === "WRONG_ACCOUNT") {
        return {
          showAccountSwitcher: true,
        };
      }
    }

    return {
      title: "We had an unexpected error loading your Canvas.",
    };
  } catch {
    return {
      title: "Something went wrong!",
    };
  }
}
